// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","268":"51517be6","455":"2c7cd7c4","484":"14cb0921","551":"c2ddb01f","828":"6cc522b3","946":"8508f210"}[chunkId] + ".chunk.js";
};